/*
 * Manful — PDP engraving editor.
 * Rich (contenteditable) input: type your message and tap a symbol to drop it at the cursor.
 * Symbols render inline in their own font, in the input AND the live canvas preview.
 *
 * Single-side products: one message (front), +£10.
 * Both-sides products: the customer chooses Front (+£10) and/or Back (+£10) — one side = £10,
 * both = £20. Each chosen side gets its own message + preview; font + symbol pickers are shared.
 *
 * Depends on: window.EngravingRules, window.EngravingPreview, window.MANFUL_ENGRAVING, and a
 * <script id="engraving-config" type="application/json"> block (engraving-config.liquid).
 */
(function () {
  var cfgEl = document.getElementById('engraving-config');
  if (!cfgEl || !window.EngravingRules || !window.EngravingPreview) { return; }
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.enabled) { return; }

  var ENG = window.MANFUL_ENGRAVING || {};
  var RULES = CFG.rules || {};
  var FONTS = RULES.allowedFonts || [];
  var FONT_LABELS = FONTS.map(function (f) { return f.label; });
  var SIDE_LABELS = CFG.sideLabels || {};
  var FRONT_LABEL = SIDE_LABELS.front || 'Front';
  var BACK_LABEL = SIDE_LABELS.back || 'Back';
  var MAX_FRONT = RULES.maxChars;                    // front / single / outside limit
  var MAX_BACK = RULES.maxCharsBack || RULES.maxChars; // back / inside limit (falls back to front)
  function rulesFor(max) { return { maxChars: max, maxLines: RULES.maxLines, charsPerLine: max, allowedFonts: FONT_LABELS, allowSymbols: !!RULES.allowSymbols }; }
  var SYMBOLS = (RULES.allowSymbols && RULES.symbols) ? RULES.symbols : [];
  var MULTI = (RULES.maxLines || 1) > 1;
  var CAN_BOTH = !!(CFG.bothSides && ENG.bothSidesId);
  var PER_SIDE = CFG.priceText || ''; // "+£10" each side
  var LOCATION = CFG.location || ''; // single-side surface label (e.g. "Inside ring engraving")

  function findForm() { return document.querySelector('form[action*="/cart/add"]'); }

  function build(form) {
    if (form.querySelector('.mf-engrave')) { return; }
    var current = FONTS[0] || { label: '', family: 'inherit' };
    // Single-side pieces name the surface on the toggle (matches the gift bundle); both-sides keep "Add engraving".
    var toggleLabel = (!CAN_BOTH && LOCATION) ? LOCATION : 'Add engraving';

    var wrap = document.createElement('div');
    wrap.className = 'mf-engrave';
    wrap.innerHTML =
      '<label class="mf-engrave__toggle"><input type="checkbox" class="mf-engrave__cb">' +
        '<span><span class="mf-engrave__toggle-lbl"></span> <span class="mf-engrave__total">' + (CFG.priceText || '') + '</span></span></label>' +
      '<div class="mf-engrave__panel" hidden>' +
        (CAN_BOTH ?
          '<div class="mf-engrave__pick">' +
            '<label class="mf-engrave__pick-opt"><input type="checkbox" class="mf-engrave__pick-front" checked> Engrave the <span class="mf-engrave__pick-front-lbl"></span> <span class="mf-engrave__price">(+' + PER_SIDE + ')</span></label>' +
            '<label class="mf-engrave__pick-opt"><input type="checkbox" class="mf-engrave__pick-back"> Engrave the <span class="mf-engrave__pick-back-lbl"></span> <span class="mf-engrave__price">(+' + PER_SIDE + ')</span></label>' +
          '</div>' : '') +
        '<div class="mf-engrave__sides"></div>' +
        '<div class="mf-engrave__fonts"></div>' +
        (SYMBOLS.length ? '<div class="mf-engrave__label-row">Tap to add a symbol where your cursor is</div><div class="mf-engrave__symbols"></div>' : '') +
        '<div class="mf-engrave__error" aria-live="polite"></div>' +
      '</div>';

    var PROP_NAMES = ['Engraving', 'Engraving (back)', 'Font', 'Lines', '_engraving_variant'];
    var hidden = {};
    PROP_NAMES.forEach(function (name) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'properties[' + name + ']'; inp.disabled = true;
      form.appendChild(inp); hidden[name] = inp;
    });

    var btn = form.querySelector('[name="add"], [type="submit"]');
    if (btn && btn.parentNode) { btn.parentNode.insertBefore(wrap, btn); } else { form.appendChild(wrap); }

    var tlbl = wrap.querySelector('.mf-engrave__toggle-lbl'); if (tlbl) { tlbl.textContent = toggleLabel; }
    var cb = wrap.querySelector('.mf-engrave__cb');
    var panel = wrap.querySelector('.mf-engrave__panel');
    var sidesBox = wrap.querySelector('.mf-engrave__sides');
    var fontsBox = wrap.querySelector('.mf-engrave__fonts');
    var symbolsBox = wrap.querySelector('.mf-engrave__symbols');
    var totalEl = wrap.querySelector('.mf-engrave__total');
    var pickFront = wrap.querySelector('.mf-engrave__pick-front');
    var pickBack = wrap.querySelector('.mf-engrave__pick-back');
    var errBox = wrap.querySelector('.mf-engrave__error');
    var pfl = wrap.querySelector('.mf-engrave__pick-front-lbl'); if (pfl) { pfl.textContent = FRONT_LABEL.toLowerCase(); }
    var pbl = wrap.querySelector('.mf-engrave__pick-back-lbl'); if (pbl) { pbl.textContent = BACK_LABEL.toLowerCase(); }

    var state = { on: false, font: current };
    var sidesOn = { front: true, back: false };
    var activeSide = null;

    // ---------- one editable side ----------
    function makeSide(name, sideMax) {
      var sw = document.createElement('div');
      sw.className = 'mf-engrave__side';
      sw.innerHTML =
        (CAN_BOTH ? '<div class="mf-engrave__side-label">' + name + '</div>' : '') +
        '<canvas class="mf-engrave__canvas"></canvas>' +
        '<div class="mf-engrave__input" contenteditable="true" role="textbox" aria-multiline="' + (MULTI ? 'true' : 'false') + '" data-ph="' + (MULTI ? 'Line 1, then press Enter for line 2' : 'Your engraving') + '"></div>' +
        '<div class="mf-engrave__count"></div>';
      var input = sw.querySelector('.mf-engrave__input');
      var canvas = sw.querySelector('.mf-engrave__canvas');
      var count = sw.querySelector('.mf-engrave__count');
      input.style.fontFamily = '"' + state.font.family + '"';

      var savedRange = null;
      function saveRange() { var sel = window.getSelection(); if (sel && sel.rangeCount && input.contains(sel.anchorNode)) { savedRange = sel.getRangeAt(0).cloneRange(); } }
      input.addEventListener('keyup', saveRange);
      input.addEventListener('mouseup', saveRange);
      input.addEventListener('focus', function () { activeSide = api; saveRange(); });
      input.addEventListener('input', onChange);
      if (!MULTI) { input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); } }); }

      function tokens() {
        var out = [];
        function pushText(t) { if (!t) { return; } var last = out[out.length - 1]; if (last && last.type === 'text') { last.value += t; } else { out.push({ type: 'text', value: t }); } }
        (function walk(node) {
          Array.prototype.forEach.call(node.childNodes, function (n) {
            if (n.nodeType === 3) { pushText(n.nodeValue); }
            else if (n.nodeType === 1) {
              if (n.classList && n.classList.contains('mf-engrave__symtok')) { out.push({ type: 'symbol', label: n.getAttribute('data-label'), char: n.getAttribute('data-char'), family: (n.style.fontFamily || '').replace(/["']/g, '') }); }
              else if (n.tagName === 'BR') { pushText('\n'); }
              else { if (/^(DIV|P)$/.test(n.tagName) && out.length) { pushText('\n'); } walk(n); }
            }
          });
        })(input);
        return out;
      }
      function composed() {
        var tk = tokens(), order = '', vtext = '', symbolUsed = false;
        tk.forEach(function (t) {
          if (t.type === 'symbol') { order += '{' + t.label + '}'; vtext += '*'; symbolUsed = true; }
          else { order += t.value; vtext += t.value; }
        });
        return { tokens: tk, order: order, vtext: vtext, visibleLen: vtext.replace(/\n/g, '').length, lines: vtext.length ? vtext.split('\n').length : 0, symbolUsed: symbolUsed };
      }
      function setCanvasSize() {
        var dpr = window.devicePixelRatio || 1;
        var w = canvas.clientWidth || 300, h = canvas.clientHeight || 96;
        canvas.width = w * dpr; canvas.height = h * dpr;
        canvas.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
        return { w: w, h: h };
      }
      function draw() {
        var dims = setCanvasSize();
        window.EngravingPreview.renderInline(canvas, composed().tokens, { width: dims.w, height: dims.h, fontSize: 38, textFont: state.font.family, color: '#1a1a1a' });
      }
      function loadAndRender() {
        if (document.fonts && document.fonts.load) {
          var fams = {}; fams[state.font.family] = 1;
          composed().tokens.forEach(function (t) { if (t.type === 'symbol' && t.family) { fams[t.family] = 1; } });
          Promise.all(Object.keys(fams).map(function (f) { return document.fonts.load('38px "' + f + '"', 'Ag').catch(function () {}); })).then(draw, draw);
        } else { draw(); }
      }
      function insertSymbol(s) {
        var span = document.createElement('span');
        span.className = 'mf-engrave__symtok'; span.setAttribute('contenteditable', 'false');
        span.setAttribute('data-label', s.label); span.setAttribute('data-char', s.char);
        span.style.fontFamily = '"' + s.family + '"'; span.textContent = s.char;
        if (!savedRange || !input.contains(savedRange.startContainer)) { input.appendChild(span); }
        else { savedRange.deleteContents(); savedRange.insertNode(span); }
        var sel = window.getSelection(); var after = document.createRange(); after.setStartAfter(span); after.collapse(true);
        sel.removeAllRanges(); sel.addRange(after); saveRange(); input.focus(); onChange();
      }
      function restyle() { input.style.fontFamily = '"' + state.font.family + '"'; }
      var api = { wrap: sw, input: input, count: count, composed: composed, draw: draw, loadAndRender: loadAndRender, insertSymbol: insertSymbol, restyle: restyle, max: sideMax, label: name };
      return api;
    }

    var front = makeSide(FRONT_LABEL, MAX_FRONT); sidesBox.appendChild(front.wrap);
    var back = CAN_BOTH ? makeSide(BACK_LABEL, MAX_BACK) : null;
    if (back) { sidesBox.appendChild(back.wrap); }
    if (CAN_BOTH) { sidesBox.classList.add('is-both'); }

    // ---------- font chips (apply to every side) ----------
    FONTS.forEach(function (f, i) {
      var chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'mf-engrave__font'; chip.textContent = f.label;
      chip.style.fontFamily = '"' + f.family + '"'; chip.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      chip.addEventListener('click', function () {
        state.font = f;
        Array.prototype.forEach.call(fontsBox.children, function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        front.restyle(); if (back) { back.restyle(); }
        onChange();
      });
      fontsBox.appendChild(chip);
    });

    // ---------- symbol chips (insert into the active side) ----------
    if (symbolsBox) {
      SYMBOLS.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mf-engrave__sym'; b.textContent = s.char;
        b.style.fontFamily = '"' + s.family + '"'; b.title = s.label; b.setAttribute('aria-label', 'Add ' + s.label);
        b.addEventListener('mousedown', function (e) { e.preventDefault(); });
        b.addEventListener('click', function () { (activeSide && activeSide.wrap.hidden === false ? activeSide : front).insertSymbol(s); });
        symbolsBox.appendChild(b);
      });
    }

    function selected() { var a = []; if (sidesOn.front) { a.push(front); } if (sidesOn.back && back) { a.push(back); } return a; }
    function sideCount() { return (sidesOn.front ? 1 : 0) + (sidesOn.back && back ? 1 : 0); }

    function applyVisibility() { front.wrap.hidden = !sidesOn.front; if (back) { back.wrap.hidden = !sidesOn.back; } }

    function applyDisabled() {
      hidden.Engraving.disabled = !(state.on && sidesOn.front);
      hidden['Engraving (back)'].disabled = !(state.on && sidesOn.back && back);
      hidden.Font.disabled = !state.on;
      hidden.Lines.disabled = !state.on;
      hidden['_engraving_variant'].disabled = !state.on;
    }

    function updateTotal() { if (totalEl) { totalEl.textContent = sideCount() >= 2 ? (ENG.priceBoth || CFG.priceText || '') : (CFG.priceText || ''); } }

    // Checkout and orders show the engraving on one line (a line break becomes a space), so label each line of a two-line engraving.
    function orderText(t) { var ls = t.split(/\r?\n/); return ls.length > 1 ? ls.map(function (l, i) { return 'Line ' + (i + 1) + ': ' + l; }).join(' / ') : t; }

    function syncProps() {
      hidden.Engraving.value = sidesOn.front ? orderText(front.composed().order) : '';
      hidden['Engraving (back)'].value = (sidesOn.back && back) ? orderText(back.composed().order) : '';
      hidden.Font.value = state.font.label;
      hidden.Lines.value = String(sidesOn.front ? front.composed().lines : (back ? back.composed().lines : 0));
      hidden['_engraving_variant'].value = String(sideCount() >= 2 ? (ENG.bothSidesId || ENG.oneSideId || '') : (ENG.oneSideId || ''));
    }

    function validateNow() {
      var sel = selected();
      if (sel.length === 0) { errBox.textContent = 'Choose ' + FRONT_LABEL.toLowerCase() + ' or ' + BACK_LABEL.toLowerCase() + ' to engrave.'; if (btn) { btn.disabled = state.on; } return false; }
      var allValid = true, firstErr = '';
      sel.forEach(function (s) {
        var c = s.composed();
        var r = window.EngravingRules.validate({ text: c.vtext, font: state.font.label, symbol: c.symbolUsed ? {} : null, lines: c.lines }, rulesFor(s.max));
        s.count.textContent = c.visibleLen + ' / ' + s.max;
        if (!r.valid) { allValid = false; if (!firstErr) { firstErr = (CAN_BOTH ? (s.label + ': ') : '') + r.errors[0]; } }
      });
      errBox.textContent = allValid ? '' : firstErr;
      if (btn) { btn.disabled = state.on && !allValid; }
      return allValid;
    }

    function onChange() { applyVisibility(); applyDisabled(); updateTotal(); if (state.on) { syncProps(); } validateNow(); selected().forEach(function (s) { s.loadAndRender(); }); }

    function paymentButtons() { return form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]'); }

    function setOn(on) {
      state.on = on; panel.hidden = !on;
      applyVisibility(); applyDisabled(); updateTotal();
      Array.prototype.forEach.call(paymentButtons(), function (el) { el.style.display = on ? 'none' : ''; });
      if (on) { syncProps(); selected().forEach(function (s) { s.loadAndRender(); }); (selected()[0] || front).input.focus(); }
      validateNow();
    }

    cb.addEventListener('change', function () { setOn(this.checked); });
    if (pickFront) { pickFront.addEventListener('change', function () { sidesOn.front = this.checked; onChange(); }); }
    if (pickBack) { pickBack.addEventListener('change', function () { sidesOn.back = this.checked; onChange(); }); }
    window.addEventListener('resize', function () { if (state.on) { selected().forEach(function (s) { s.draw(); }); } });

    applyVisibility();
    front.count.textContent = '0 / ' + MAX_FRONT;
  }

  function init() { var form = findForm(); if (form) { build(form); } }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
